import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { TrainingModel } from '../../models/training-model'
import { UserProfileTrainingCertificate } from '../../models/user-profile-training-certificate'
import { UserProfileTrainingCertificateGateway } from '../../gateways/user-profile-training-certificate-gateway'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { TrainingStateGateway } from '../../gateways/training-state-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'training-review',
    templateUrl: './training-review.component.html',
    styleUrls: ['./training-review.component.scss']
})
export class TrainingReviewComponent implements OnInit {
    userProfileTrainingCertificates: Array<UserProfileTrainingCertificate> = []
    currentUser: CurrentUser
    selectedUserProfile: UserProfileTrainingCertificate | null
    currentYearCourses: TrainingModel[]
    nextYearCourses: TrainingModel[]
    public loading: boolean = true
    public innerloading: boolean = false
    currentYear: number
    nextYear: number
    validForm: boolean
    selectedYear1: boolean | null
    ErrorMessages: any[]
    selectedYear2: boolean | null
    nextYearErrored: boolean
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    constructor(
        private trainigCertificateGateway: UserProfileTrainingCertificateGateway,
        private currentUserGateway: CurrentUserGateway,
        private trainingStateGateway: TrainingStateGateway,
        public _global: PortalGlobals
    ) {
        // this.currentYear = this._global.selectedPlanYear;
        // this.nextYear = this.currentYear + 1;
    }
    ngOnInit() {
        this.validForm = true
        this.loading = true
        this.ErrorMessages = []
        this.currentUserGateway.getCurrentUser().subscribe((user: CurrentUser) => {
            this.currentUser = user
            this.trainigCertificateGateway
                .getPendingTrainingCerificatesByOrgID(parseInt(user.orgId))
                .subscribe((certificates: UserProfileTrainingCertificate[]) => {
                    this.userProfileTrainingCertificates = certificates //.filter(t => t.CreditApplied === false)
                })
            this.trainigCertificateGateway.OpenPlanYears().subscribe((OpenPlanYears: number[]) => {
                // this.userProfileTrainingCertificates = certificates //.filter(t => t.CreditApplied === false)
                this.currentYear = OpenPlanYears[0]
                if (OpenPlanYears.length > 1) this.nextYear = OpenPlanYears[1]
            })
            this.loading = false
        })
    }
    loadingupdateCourses(user: UserProfileTrainingCertificate) {
        this.validForm = true
        this.ErrorMessages = []
        this.innerloading = true
        this.updateCourses(user)
        this.innerloading = false
    }
    updateCourses(user: UserProfileTrainingCertificate | null) {
        this.loading = true
        // if clicked user and selected user is same,
        // make selected user null to close courses list
        if (this.selectedUserProfile == user) {
            this.selectedUserProfile = null
            this.loading = false
            return
        }
        this.selectedUserProfile = user
        this.selectedYear1 = false
        this.selectedYear2 = false
        this.currentYearCourses = []
        this.nextYearCourses = []
        // if all courses status is passed then dont set respective course variable
        /*
        this.trainingStateGateway.GetUserTrainingDetails(user.UserProfileID, this.currentYear)
            .subscribe(courses => this.currentYearCourses = (courses || []).every(t => t.Status === "passed") ? [] : courses);
        this.trainingStateGateway.GetUserTrainingDetails(user.UserProfileID, this.nextYear)
            .subscribe(courses => this.nextYearCourses = (courses || []).every(t => t.Status === "passed") ? [] : courses, () => {
                this.nextYearErrored = true;
            });
        */

        this.trainingStateGateway.GetUserTrainingDetails(user?.UserProfileID || 0, this.currentYear).subscribe(
            (courses) => {
                if (courses.length > 0) {
                    this.currentYearCourses = courses
                }
                this.innerloading = false
                this.loading = false
            },
            (err) => {
                this.innerloading = false
                this.loading = false
            }
        )
        if (this.nextYear !== undefined) {
            this.trainingStateGateway.GetUserTrainingDetails(user?.UserProfileID || 0, this.nextYear).subscribe(
                (courses) => {
                    if (courses.length > 0) {
                        this.nextYearCourses = courses
                    }
                    this.nextYearErrored = false
                    this.innerloading = false
                    this.loading = false
                },
                (err) => {
                    this.innerloading = false
                    this.loading = false
                }
            )
        }
    }

    showCertificate(userProfileTrainingCertificateID: number) {
        this.trainigCertificateGateway.showTrainingCerificate(userProfileTrainingCertificateID)
    }
    onselectedYear1Check() {
        this.selectedYear1 = !this.selectedYear1
    }

    onselectedYear2Check() {
        this.selectedYear2 = !this.selectedYear2
    }
    applyCredits() {
        this.validForm = true
        this.ErrorMessages = []
        if (!(this.selectedYear1 || this.selectedYear2) || !this.selectedUserProfile) {
            this.validForm = false
            this.ErrorMessages.push('Please select the Plan Year for Training')
            this.focusableEleTop.nativeElement.focus()
            return
        }

        this.loading = true
        this.trainigCertificateGateway
            .addNextYearTrainingForUser(
                this.selectedUserProfile.UserProfileID,
                this.selectedYear1 ? this.currentYear : 0,
                this.selectedYear2 ? this.nextYear : 0,
                this.selectedUserProfile.UserProfileTrainingCertificateID
            )
            .subscribe(
                (nextYearTrainingDetails) => {
                    if (nextYearTrainingDetails) {
                        /*
                    for (let i = 0; i < this.userProfileTrainingCertificates.length; i++) {
                        //if (this.userProfileTrainingCertificates[i].UserProfileID == this.selectedUserProfile.UserProfileID)
                        if (this.userProfileTrainingCertificates[i].UserProfileTrainingCertificateID == this.selectedUserProfile.UserProfileTrainingCertificateID){
                            this.userProfileTrainingCertificates[i].CreditAppliedStatus = "A";
                        }
                    }
                    */
                        this.LoadGrid()
                        this.updateCourses(this.selectedUserProfile)

                        this.selectedUserProfile = null
                        this.loading = false
                        this.focusableEleTop.nativeElement.focus()
                        //this.selectedYear1 = null;
                        //this.selectedYear2 = null;
                    }
                },
                (err) => {
                    this.loading = false
                    this.focusableEleTop.nativeElement.focus()
                }
            )
    }
    LoadGrid() {
        this.trainigCertificateGateway
            .getPendingTrainingCerificatesByOrgID(parseInt(this.currentUser.orgId))
            .subscribe((certificates: UserProfileTrainingCertificate[]) => {
                this.userProfileTrainingCertificates = certificates //.filter(t => t.CreditApplied === false)
            })
    }

    inValid() {
        this.validForm = true
        this.ErrorMessages = []
        this.loading = true
        this.trainigCertificateGateway.inValidTrainingCertificate(this.selectedUserProfile?.UserProfileTrainingCertificateID || 0).subscribe(
            (isSuccess) => {
                if (isSuccess) {
                    /*
                    for (let i = 0; i < this.userProfileTrainingCertificates.length; i++) {
                        if (this.userProfileTrainingCertificates[i].UserProfileID == this.selectedUserProfile.UserProfileID) {
                            this.userProfileTrainingCertificates[i].CreditAppliedStatus = "I";
                        }
                    }
                    */
                    this.LoadGrid()
                    //this.updateCourses(this.selectedUserProfile);

                    this.selectedUserProfile = null
                    this.selectedYear1 = null
                    this.selectedYear2 = null
                    this.loading = false
                    this.focusableEleTop.nativeElement.focus()
                }
            },
            (err) => {
                this.loading = false
                this.focusableEleTop.nativeElement.focus()
            }
        )
    }
}
